import { decode as base64_decode, encode as base64_encode } from "base-64";
import RootStore from "./RootStore";
import { postApi, baseURL } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";
import { message } from "antd";

class StoppageReportStore {
  stoppageReport = [];
  stoppageArray = [];
  total = 0;
  loading = false;
  loadingData = false;
  pageSize = 50;
  remaning_vehicleId = "";
  last_record_timestamp = "";
  pythonReportMessage = false;
  pythonReportErrorMessage = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      stoppageReport: observable,
      remaning_vehicleId: observable,
      last_record_timestamp: observable,
      pageSize: observable,
      stoppageArray: observable,
      total: observable,
      loading: observable,
      loadingData: observable,
      loadData: action,
      exportExcel: action,
      exportpdf: action,
      exportcsv: action,
      exportxml: action,
      totalStoppageReport: action,
      pythonReportMessage: observable,
      pythonReportErrorMessage: observable,
    });
    this.rootStore = rootStore;
  }

  async loadData({
    companyId,
    offset,
    limit,
    vehicleId,
    toDate,
    fromDate,
    interval,
    pageNo,
  }) {
    this.loading = true;
    var postData = {
      companyId: companyId,
      vehicleId: vehicleId,
      interval: interval,
      fromDate: fromDate,
      toDate: toDate,
      offset: offset,
      limit: limit,
      page: pageNo,
    };

    if (config.pythonReport === 1) {
      // postData.companyId=10166
      // postData.vehicleId=[26375]
      if (offset === 0) {
        postData.last_record_timestamp = "";
        postData.remaning_vehicleId = "";
      } else {
        postData.last_record_timestamp = this.last_record_timestamp;
        postData.remaning_vehicleId = this.remaning_vehicleId;
      }
      var response = await postApi
        .getClient("report")
        .post("/tracking_report/stoppage", postData);
      this.total = parseInt(response?.data?.data?.TotalCount);
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post("index.php?c=vehicle&a=stopreport", "postData=" + base64Input);
      this.total = parseInt(response?.data?.data?.TotalCount);
      this.pageSize = response?.data?.data?.StopData?.length;
    }

    if (config.pythonReport === 1) {
      this.last_record_timestamp = response?.data?.data?.last_record_timestamp;
      this.remaning_vehicleId = response?.data?.data?.remaning_vehicleId;
    }

    this.stoppageReport = response?.data?.data?.StopData;
    this.loading = false;
  }

  async totalStoppageReport({
    companyId,
    offset,
    limit,
    vehicleId,
    toDate,
    fromDate,
    interval,
    pageNo,
  }) {
    if (config.pythonReport !== 1) {
      this.loadingData = true;
      var postData = {
        companyId: companyId,
        vehicleId: vehicleId,
        interval: interval,
        fromDate: fromDate,
        toDate: toDate,
        offset: offset,
        limit: limit,
      };
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post(
          "index.php?c=vehicle&a=totalStopageReport",
          "postData=" + base64Input
        );
      this.stoppageArray = response?.data?.data;
      this.loadingData = false;
    } else {
      var postData = {
        companyId: companyId,
        vehicleId: vehicleId,
        interval: interval,
        fromDate: fromDate,
        toDate: toDate,
        offset: offset,
        limit: limit,
        page: pageNo,
        total: true,
      };
      // if (offset === 0) {
      //   postData.last_record_timestamp = "";
      //   postData.remaning_vehicleId = "";
      // } else {
      //   postData.last_record_timestamp = this.last_record_timestamp;
      //   postData.remaning_vehicleId = this.remaning_vehicleId;
      // }
      var response = await postApi
        .getClient("report")
        .post("/tracking_report/stoppage", postData);
      this.stoppageArray = response?.data?.data?.StopData;
      this.loadingData = false;
    }
  }

  async exportExcel(getData) {
    if (config.pythonReport === 1) {
      getData = { ...getData, language: "english" };
      // getData = { ...getData, companyId: 10166 }
      // getData = { ...getData, vehicleId: [26375] }
      try {
        await postApi
          .getClient("report")
          .post("/tracking_report/stoppage/download/excel", getData, {
            responseType: "blob",
          });
        this.pythonReportMessage = true;
        // await message.success("The report will be generated shortly. You can check its status in the pending report list.", 2);
      } catch (error) {
        this.pythonReportErrorMessage = false;
        message.error("Failed to download the report. Please try again.");
      }
    } else {
      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=vehicle&a=exportstopexcel&cid=" +
        getData.companyId +
        "&userId=" +
        getData.userId +
        "&vid=" +
        getData.vehicleId +
        "&int=" +
        getData.interval +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;
    }
  }

  async exportpdf(getData) {
    if (config.pythonReport === 1) {
      getData = { ...getData, language: "english" };
      // getData = { ...getData, companyId: 10166 }
      // getData = { ...getData, vehicleId: [26375] }
      try {
        await postApi
          .getClient("report")
          .post("/tracking_report/stoppage/download/pdf", getData, {
            responseType: "blob",
          });
        this.pythonReportMessage = true;
        // await message.success("The report will be generated shortly. You can check its status in the pending report list.", 2);
      } catch (error) {
        this.pythonReportErrorMessage = false;
        message.error("Failed to download the report. Please try again.");
      }
    } else {
      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=vehicle&a=exportstoppdf&cid=" +
        getData.companyId +
        "&userId=" +
        getData.userId +
        "&vid=" +
        getData.vehicleId +
        "&int=" +
        getData.interval +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;
    }
  }

  async exportcsv(getData) {
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportstopcsv&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&vid=" +
      getData.vehicleId +
      "&int=" +
      getData.interval +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList;
  }
  async exportxml(getData) {
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportstopxml&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&vid=" +
      getData.vehicleId +
      "&int=" +
      getData.interval +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList;
  }
}

export default StoppageReportStore;
